import React from "react"
import { partenaireItemImg } from "../partenaires.module.scss"
import NonStretchedImage from "../../../Image/non-stretched-image"
import PropTypes from "prop-types"
import ProcessedLink from "../../../processed-link"

const PartenaireItem = ({ partenaire }) => {
  let image = ""
  if (
    partenaire.relationships.image_direct_link.localFile.extension === "svg"
  ) {
    image = (
      <img
        className={partenaireItemImg}
        src={
          partenaire.relationships.image_direct_link.localFile
            .SlugifiedPublicUrl
        }
        alt={partenaire.image_direct_link.alt || ""}
      />
    )
  } else if (partenaire.relationships?.image_direct_link?.localFile) {
    image = (
      <NonStretchedImage
        alt={partenaire.image_direct_link.alt}
        className={partenaireItemImg}
        {...partenaire.relationships.image_direct_link.localFile}
      />
    )
  }
  return <ProcessedLink link={partenaire.url.uri}>{image}</ProcessedLink>
}

PartenaireItem.propTypes = {
  partenaire: PropTypes.object.isRequired,
}

export default PartenaireItem
